import {
  PAYMENT_OTHER_ALL,
  PAYMENT_OTHER_GET,
  PAYMENT_OTHER_DELETE,
  PAYMENT_OTHER_PUT,
  PAYMENT_OTHER_POST,
  PAYMENT_OTHER_LOADING,
  PAYMENT_OTHER_ERROR,
} from '../../actions/types';

const initialState = {
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PAYMENT_OTHER_LOADING:
      return { isLoading: true, isCompleted: true };
    case PAYMENT_OTHER_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case PAYMENT_OTHER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_OTHER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_OTHER_POST:
      return { isLoading: false, isCompleted: true };
    case PAYMENT_OTHER_PUT:
      return { isLoading: false, isCompleted: true };
    case PAYMENT_OTHER_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
